import React, { useRef, useState, useEffect } from 'react';
import { Button, Image as BootstrapImage } from 'react-bootstrap';

import folderIcon from '../assets/icon/folder.svg';

interface AddImageLogoProps {
  title: string;
  selectedFile: File | null;
  setSelectedFile: (file: File) => void;
}

const AddImageLogo = ({
  title,
  selectedFile,
  setSelectedFile,
}: AddImageLogoProps): JSX.Element => {
  const refInputImage = useRef<HTMLInputElement>(null);

  const [img, setImg] = useState<HTMLImageElement>(() => new Image());

  const handleImageChange = (e: any): void => {
    const file = e.target.files[0];

    if (file) {
      // Armazena o arquivo no state
      setSelectedFile(file);
      const imgTemp = new Image();

      imgTemp.onload = () => {
        setImg(imgTemp);
      };

      imgTemp.src = URL.createObjectURL(file);
    }
  };

  useEffect(() => {
    // Cria uma URL temporária para a imagem
    if (selectedFile) {
      const imgTemp = new Image();

      imgTemp.onload = () => {
        setImg(imgTemp);
      };

      imgTemp.src = URL.createObjectURL(selectedFile);
    }
  }, [selectedFile]);

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 bytes';
    if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    if (bytes >= 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${bytes} bytes`;
  };

  return (
    <div className="d-flex mx-2">
      <div
        className="w-100 overflow-hidden"
        style={{
          borderRadius: '0.68rem',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div style={{ background: '#000' }}>
          <span
            className="ms-2 w-100"
            style={{
              color: '#fff',
              fontWeight: 'bold',
              fontSize: '1.2rem',
            }}
          >
            {title}
          </span>
        </div>
        <div className="d-flex flex-column mx-2 mb-1">
          <span className="mt-1" style={{ color: '#828282' }}>
            Tamanho recomendado da imagem: 500x500
          </span>
          <div
            className="d-flex align-items-center justify-content-between my-1 border border-1"
            style={{
              borderRadius: '0.68rem',
            }}
          >
            <div className="d-flex align-items-center justify-content-cente align-items-center ps-2 py-2">
              <div
                className="overflow-hidden"
                style={{
                  width: '4rem',
                  height: '4rem',
                  background: '#D9D9D9',
                  borderRadius: '0.68rem',
                  border: '1px solid',
                }}
              >
                {selectedFile && (
                  <BootstrapImage
                    className="h-100 w-100 "
                    src={URL.createObjectURL(selectedFile)}
                    style={{
                      objectFit: 'contain',
                    }}
                  />
                )}
              </div>

              <div className="d-flex flex-column ms-2">
                <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                  {selectedFile?.name ? selectedFile?.name : ' - '}
                </span>

                <span>{`${formatFileSize(selectedFile?.size || 0)} - ${
                  img.naturalHeight
                }x${img.naturalWidth}`}</span>
              </div>
            </div>
            <div className="py-2 pe-2">
              <Button
                className="d-flex align-items-center "
                variant="secondary"
                style={{
                  borderRadius: '0.68rem',
                }}
                onClick={() => refInputImage.current?.click()}
              >
                <BootstrapImage
                  src={folderIcon}
                  alt="Pasta"
                  style={{ height: '1.4rem', width: '1.5rem' }}
                />
                <span className="ms-1 mt-1">Selecionar</span>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  accept=".jpg,.jpeg,.png"
                  onChange={handleImageChange}
                  ref={refInputImage}
                />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddImageLogo;
